export default {
	props: {
		alwaysOn:{type:Boolean, default:false},
		extLabel: String, //work as label
		maxRooms: {type:Number, default:10},
		minGuestsPerRoom: {type:Number, default:1},
		maxGuestsPerRoom: {type:Number, default:5},
		childrenAccepted: {type:Boolean, default:true},
		minChildrenAges: {type:Number, default:0},
		maxChildrenAges: {type:Number, default:0},
		value:{type:Array, default:()=>([])},
	},
	data(){
		return {
			minRooms: 1,
			minChildrenPerRoom: 0,
			dialog: false,
			validationClass: '',
		}
	},
	watch: {
		value:{
			deep:true,
			handler(v){
				if(this.validationClass){
					this.$nextTick(()=>{ this.validate(); });
				}
			},
		},
	},
	computed:{
		roomsGuests:{
			get(){
				return this.value;
			},
			set(v){
				this.value = v;
			},
		},
		numRooms(){
			return this.roomsGuests.length;
		},
		numAdults(){
			let n=0;
			for(const el of this.roomsGuests){
				n+=el.adults;
			}
			return n;
		},
		numChildren(){
			let n=0;
			for(const el of this.roomsGuests){
				n+=el.children;
			}
			return n;
		},
		guestsText(){
			let r = [];
			if(this.numAdults>=0){
				r.push(this.$tc('numAdults', this.numAdults));
			}
			if(this.numChildren>=0){
				r.push(this.$tc('numChildren', this.numChildren));
			}
			if(!r.length){
				r.push(this.$t('guests'));
			}
			return r.join(', ');
		},
	},
	methods: {
		onAddRoom(){
			let numRooms = this.numRooms;
			if(numRooms<this.maxRooms){
				this.$set(this.roomsGuests, numRooms, {adults:this.minGuestsPerRoom, children:this.minChildrenPerRoom, children_ages:[]});
				this.$emit('add-room');
			}
		},
		onDeleteRoom(i){
			if(i+1>this.minRooms){
				window.setTimeout(()=>{ this.roomsGuests.splice(i,1); },1);
				this.$emit('delete-room');
			}
		},
		onChangeChildren(pos, newSize){
			let oldSize = this.roomsGuests[pos].children_ages.length;
			let diff = newSize - oldSize;
			if(diff>0){
				while(diff>0){
					this.$set(this.roomsGuests[pos].children_ages, this.roomsGuests[pos].children_ages.length, -1);
					diff--;
				}
			}
			else if(diff<0){
				this.roomsGuests[pos].children_ages.splice(newSize);
			}
		},
		onShowDDList(){
			this.dialog = true;
			this.validate();
		},
		onHideDDList(){
			this.dialog = false;
		},
		onDialogToggle(){
			this.dialog = !this.dialog;
			this.$emit(this.dialog?'show':'hide');
		},
		onClickButtonOk(){
			if(this.validate()){
				this.onDialogToggle();
			}
		},
		validate(){
			let isValid = true;
			if(!this.roomsGuests || !this.roomsGuests.length){
				isValid = false;
			}
			else if(this.childrenAccepted){
				for(const i in this.roomsGuests){
					if(!this.$refs['qitChildAge_'+i]) continue;
					for(const el of this.$refs['qitChildAge_'+i]){
						if(!el.validate()){ isValid = false;}
					}
				}
			}
			this.validationClass = isValid ? '' : 'invalid';
			return isValid;
		}
	},

	mounted(){
		window.addEventListener('click', (ev)=>{
			if(this.dialog && !this.$refs.qitRoomsGuests.contains(ev.target)){
				this.onDialogToggle();
			}
		});
	},
	template: `
<div ref="qitRoomsGuests" :class="['qit-search-rooms-guests dropdown-list-control', alwaysOn?'always-on':'', validationClass]">
	<div :class="['styled-select v2 no-select', validationClass]" @click="onDialogToggle">
		<label v-if="extLabel" class="ext-label">{{extLabel}}</label>
		<span class="inner-text">{{guestsText}}</span>
	</div>
	<div :class="['dropdown-list', dialog?'show':'']">
		<div class="room-box" v-for="(roomGuests, i) in roomsGuests">
			<div class="room-title" v-if="minRooms<maxRooms">
				<div v-text="$t('room')+' '+(i+1)"></div>
				<span v-if="(i+1)>minRooms" class="qicon-1 clear-icon active small" @click="onDeleteRoom(i)">remove</span>
			</div>
			<qit-inc-dec 
					:label="$t('adults')" 
					v-model="roomsGuests[i].adults" 
					:min-val="minGuestsPerRoom" 
					:max-val="maxGuestsPerRoom - parseInt(roomsGuests[i].children?roomsGuests[i].children:0)"
					@inc="$emit('add-adult')"
					@dec="$emit('delete-adult')"
			></qit-inc-dec>
			<template v-if="childrenAccepted">
				<qit-inc-dec
            class="mb-0"
            :label="$t('children')"
            v-model="roomsGuests[i].children"
            :min-val="minChildrenPerRoom"
						:max-val="maxGuestsPerRoom - parseInt(roomsGuests[i].adults?roomsGuests[i].adults:1)"
            @inc="$emit('add-child')"
            @dec="$emit('delete-child')"
            @input="onChangeChildren(i,$event)"
				></qit-inc-dec>
				<qit-child-age v-for="(v,j) in roomsGuests[i].children_ages" :ref="'qitChildAge_'+i" :label="$t('AgeOfChild', {i:j+1})" v-model="roomsGuests[i].children_ages[j]" :min-val="minChildrenAges" :max-val="maxChildrenAges"/>
			</template>
		</div>
		<div class="bottom">
			<button v-if="minRooms<maxRooms" type="button" :disabled="numRooms>=maxRooms" @click="onAddRoom">+ {{$t('addRoom')}}</button>
			<span v-else></span>
			<button type="button" @click="onClickButtonOk">OK</button>
		</div>
	</div>
</div>
`,
}
